import { MapWrapper } from '@openlayers/MapWrapper';
import { transform as olTransform } from 'ol/proj';
import { unByKey } from 'ol/Observable';
import * as React from 'react';
import { observer } from 'mobx-react';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { makeObservable, observable } from 'mobx';
import { Button } from '@shared/ui-react/Button';
import { SelectionMapMarkers } from '@openlayers/SelectionMapMarkers';

export class MapLocationPickerTool implements MapTool {
    mapMarkers: SelectionMapMarkers;
    destinationClickHandler = null;
    @observable target = {
        lat: null,
        lon: null,
        isLoading: false,
    };
    uiWrapper: HTMLDivElement;

    constructor(
        public mapWrapper: MapWrapper,
        public origin: { lat: number; lon: number },
        public onDeactivate: Function,
        public onSelected: Function,
        public onCancel: Function,
        public confirmLabel?: string
    ) {
        makeObservable(this);
    }

    activate() {
        this.mapMarkers = new SelectionMapMarkers(this.mapWrapper);

        if (this.origin) {
            this.mapMarkers.drawMarkersDestinationLines([
                {
                    geographicPoint: this.origin,
                },
            ]);
        }

        this.destinationClickHandler = this.mapWrapper.events.onClick(e => {
            if (this.target.isLoading) return;
            const coords = e.coordinate;
            const [lon, lat] = olTransform(coords, 'EPSG:3857', 'EPSG:4326');
            this.target.lon = lon;
            this.target.lat = lat;
            this.mapMarkers?.setDestinationLinesTarget(lat, lon);
        });

        $(document.body).append(
            '<div id="map-location-picker-ui"  class="card padded-half" style="position: fixed; top: 80px; left: 50%; z-index: 9; transform: translateX(-50%)"></div>'
        );
        this.uiWrapper = document.querySelector('#map-location-picker-ui');

        ReactUtils.safeRender(
            <MapLocationPickerToolUI target={this.target} cancel={this.onCancelCalled} confirm={this.onConfirmedCaller} confirmLabel={this.confirmLabel} />,
            this.uiWrapper
        );
    }

    deactivate = () => {
        this.mapMarkers.destroy();
        this.mapMarkers = null;
        unByKey(this.destinationClickHandler);
        this.uiWrapper.remove();
    };

    onCancelCalled = () => {
        this.onDeactivate();
        if (this.onCancel) {
            this.onCancel();
        }
    };

    onConfirmedCaller = async () => {
        try {
            this.target.isLoading = true;
            await this.onSelected(this.target.lat, this.target.lon);
        } catch {}
        this.target.isLoading = false;
        this.onDeactivate();
    };
}

@observer
class MapLocationPickerToolUI extends React.Component<{
    target: GeographicPoint & { isLoading: boolean };
    cancel: Function;
    confirm: Function;
    confirmLabel?: string;
}> {
    render() {
        if (!this.props.target.lat) {
            return <div>{__('js_map.click_to_select_new_location')}</div>;
        }
        return (
            <div className='flex-row gap-half'>
                <Button onClick={this.props.cancel} disabled={this.props.target.isLoading} icon='iki iki-cross' />
                <Button onClick={this.props.confirm} loading={this.props.target.isLoading} className='ik-button-primary'>
                    {this.props.confirmLabel ?? __('js_map.save_new_location')}
                </Button>
            </div>
        );
    }
}
